<template>
  <PageTemplate>
    <Loader v-if="!isLoaded"/>
    <div v-else>
      <div class="element-box">
        <CoachingOverviewData :coaching="coachingData"/>
        <Menu :coaching="coachingData"
              :currentUser="piniaCurrentUser"/>

        <form v-if="isLoaded" @submit.prevent="submitForm" novalidate>
          <div class="text-center mt-5 mb-5">
            <h5>Bestätigung der Teilnahme</h5>
            <h6>Abrechnung des Fallmanagements nach psychosomatischer Rehabilitation</h6>
          </div>

          <div class="row mb-4">
            <div class="col-12">
              <h6 class="mb-3">Angaben der Versicherten / des Versicherten zur Erwerbstätigkeit und
                Arbeitsfähigkeit</h6>
              <TextEditor
                  v-model="formData.informationFromTheInsured"
                  @update:model-value="formData.informationFromTheInsured = $event"
                  :inputStyle="{ height: '200px' }"/>
            </div>
          </div>

          <div class="row" style="margin-top: 50px;">
            <div class="col-xl-2 col-lg-3 col-md-3 col-sm-12">
              <BaseCheckbox
                  v-model="formData.interimSettlement"
                  label="Zwischenabrechnung"
                  :labelPosition="'right'"/>
            </div>
            <div class="col-lg-1 col-md-2 col-sm-2 ms-0 ps-0 text-center">Zeitraum von</div>
            <div class="col-lg-2 col-md-2 col-sm-3">
              <Datepicker
                  v-model="formData.interimSettlementPeriodOf"
                  :required="true"/>
            </div>
            <div class="col-lg-1 col-md-1 col-sm-1 text-center">bis</div>
            <div class="col-lg-2 col-md-2 col-sm-3">
              <Datepicker
                  v-model="formData.interimSettlementPeriodTill"
                  :required="true"/>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-2 col-lg-3 col-md-3 col-sm-12">
              <BaseCheckbox
                  v-model="formData.finalSettlement"
                  label="Schlussabrechnung"
                  :labelPosition="'right'"/>
            </div>
            <div class="col-lg-1 col-md-2 col-sm-2 ms-0 ps-0 text-center">Zeitraum von</div>
            <div class="col-lg-2 col-md-2 col-sm-3">
              <Datepicker
                  v-model="formData.finalSettlementPeriodOf"
                  :required="true"/>
            </div>
            <div class="col-lg-1 col-md-1 col-sm-1 text-center">bis</div>
            <div class="col-lg-2 col-md-2 col-sm-3">
              <Datepicker
                  v-model="formData.finalSettlementPeriodTill"
                  :required="true"/>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-6 col-md-8 col-sm-12">
              <BaseCheckbox
                  v-model="formData.beginningOfCaseManagement"
                  label="Beginn des Fallmanagements"
                  :labelPosition="'right'"/>
            </div>
            <div class="col-lg-2 col-md-3 col-sm-3">
              <Datepicker
                  v-model="formData.dateOfCaseManagementBeginning"
                  :required="true"/>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-6 col-md-8 col-sm-12">
              <BaseCheckbox
                  v-model="formData.firstConsultationDuringRehabilitation"
                  label="Erstgespräch in der Rehabilitationsklinik am"
                  :labelPosition="'right'"/>
            </div>
            <div class="col-lg-2 col-md-3 col-sm-3">
              <Datepicker
                  v-model="formData.dateOfTheFirstConsultationDuringRehabilitation"
                  :required="true"/>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-6 col-md-8 col-sm-12">
              <BaseCheckbox
                  v-model="formData.firstInterviewAfterRehabilitation"
                  label="Erstgespräch nach der Reha"
                  :labelPosition="'right'"/>
            </div>
            <div class="col-lg-2 col-md-3 col-sm-3">
              <Datepicker
                  v-model="formData.dateOfTheFirstInterviewAfterRehabilitation"
                  :required="true"/>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-6 col-md-8 col-sm-12">
              <BaseCheckbox
                  v-model="formData.endOfCaseManagement"
                  label="Das Fallmanagement endet voraussichtlich am"
                  :labelPosition="'right'"/>
            </div>
            <div class="col-lg-2 col-md-3 col-sm-3">
              <Datepicker
                  v-model="formData.dateOfCaseManagementEnd"
                  :required="true"/>
            </div>
          </div>

          <div class="row">
            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12">
              <BaseCheckbox
                  v-model="formData.theCaseManagementSuccessfullyCompleted"
                  label="Das Fallmanagement wurde am"
                  :labelPosition="'right'"/>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-3">
              <Datepicker
                  v-model="formData.dateOfCaseManagementCompletion"
                  :required="true"/>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-4">
              erfolgreich beendet
            </div>
          </div>

          <div class="row">
            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12">
              <BaseCheckbox
                  v-model="formData.caseManagementCanceled"
                  label="Das Fallmanagement wurde am"
                  :labelPosition="'right'"/>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-3">
              <Datepicker
                  v-model="formData.dateOfCaseManagementCancellation"
                  :required="true"/>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-4">
              abgebrochen
            </div>
          </div>

          <div class="d-flex justify-content-center w-100 mt-4">
            <SaveButton
                :label="$t('general.button.save')"
                :loading="isSubmitting"/>
          </div>
        </form>
      </div>
    </div>
  </PageTemplate>
</template>

<script setup>
import portalCaseManagementCoachingService from '@/api/Portal/CaseManagementCoaching';
import caseManagementCoachingCoachingService from '@/api/Unemployed/CaseManagementCoaching';
import BaseCheckbox from '@/components/base/BaseCheckbox.vue';
import Loader from '@/components/Loader.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import Datepicker from '@/components/picker/Datepicker.vue';
import TextEditor from '@/components/TextEditor.vue';
import {CloseToast, ErrorToast, SuccessToast} from '@/components/VueToast';
import {piniaUserStore} from '@/store/piniaUserStore';
import CoachingOverviewData from '@/views/App/Portal/CaseManagementCoaching/CoachingOverviewData.vue';
import Menu from '@/views/App/Portal/CaseManagementCoaching/Menu.vue';
import {computed, onMounted, ref} from 'vue';
import {useI18n} from 'vue-i18n';
import {useRoute} from 'vue-router';
import SaveButton from '@/components/button/SaveButton.vue';

const piniaUserState = piniaUserStore();
const piniaCurrentUser = computed(() => piniaUserState.currentUser.user);
const {t} = useI18n();
const route = useRoute();
const coachingData = ref('');
const isLoaded = ref(false);
const isSubmitting = ref(false);
const coachingId = +route.params.id;
const clientId = ref(null)

const formData = ref({
  coachingId: '',
  informationFromTheInsured: '',
  interimSettlement: false,
  interimSettlementPeriodOf: '',
  interimSettlementPeriodTill: '',
  finalSettlement: false,
  finalSettlementPeriodOf: '',
  finalSettlementPeriodTill: '',

  beginningOfCaseManagement: false,
  dateOfCaseManagementBeginning: '',
  firstConsultationDuringRehabilitation: false,
  dateOfTheFirstConsultationDuringRehabilitation: '',
  firstInterviewAfterRehabilitation: false,
  dateOfTheFirstInterviewAfterRehabilitation: '',

  endOfCaseManagement: false,
  dateOfCaseManagementEnd: '',
  theCaseManagementSuccessfullyCompleted: false,
  dateOfCaseManagementCompletion: '',
  caseManagementCanceled: false,
  dateOfCaseManagementCancellation: '',
});

async function submitForm() {
  if (isSubmitting.value) return;
  isSubmitting.value = true;

  try {
    formData.value.coachingId = +coachingId;

    await portalCaseManagementCoachingService.submitConfirmationBillingReport(formData.value);

    await getConfirmationBillingData();
    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSubmitting.value = false;
  }
}

async function getCoachingData() {
  try {
    CloseToast();
    const {data} = await caseManagementCoachingCoachingService.getCaseManagementCoaching(+coachingId);

    coachingData.value = data.data;
    clientId.value = data?.data?.client?.id;
  } catch (error) {
    await ErrorToast(error);
  }
}

async function getConfirmationBillingData() {
  try {
    const {data} = await portalCaseManagementCoachingService.getConfirmationBillingReport(+coachingId);

    formData.value = {...data.data};
  } catch (error) {
    await ErrorToast(error);
  }
}

onMounted(async () => {
  await Promise.all([
    getCoachingData(),
    getConfirmationBillingData(),
  ]);

  isLoaded.value = true;
});
</script>
<style scoped>

</style>